import cn from 'client/utils/cn';
import LangContext from 'client/utils/lang-context';

import React, { Component } from 'react';

import { PagePressReleasesProps } from 'client/bundles/types';
import { AutoscrollerStoragePrefix } from 'client/components/helpers/autoscroller';
import MenuYears from 'client/components/menu-years';
import PressReleaseItem from 'client/components/press-release-item';
import Subscribe from 'client/components/subscribe';
import TextNoData from 'client/components/text-no-data';

import './index.css';

const b = cn('press-releases');
const bPageTitle = cn('page-title');

interface Props extends PagePressReleasesProps {
    baseUrl: string;
}

class PressReleases extends Component<Props> {
    static contextType = LangContext;

    render() {
        const { title, items, years, currentYear, messages } = this.props;
        const { lang } = this.context;

        return (
            <div className={b()}>
                <h1 className={bPageTitle()}>{title}</h1>

                <div className={b('filters')}>
                    {currentYear && years && years.length > 0 &&
                        <MenuYears
                            currentYear={currentYear}
                            years={years}
                            storagePrefix={AutoscrollerStoragePrefix.PressReleases}
                            />
                    }
                </div>

                {items && items.length > 0 ?
                    <div className={b('content')}>
                        <div className={b('items')}>
                            { items.map(item => (<PressReleaseItem release={item} key={item.date} />)) }
                        </div>

                        {
                            lang === 'en' &&
                            <div className={b('subscribe')}>
                                <Subscribe />
                            </div>
                        }
                    </div> :
                    <TextNoData text={messages.notAvailable} />
                }
            </div>
        );
    }
}

export default PressReleases;
